import React from 'react';
import clsx from 'clsx';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const allowedElements = [
  'br',
  'p',
  'em',
  'strong',
  'hr',
  'blockquote',
  'a',
  'ol',
  'ul',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'code',
  'pre',
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
];

const MarkdownRender = ({ value, className, linkTarget }) => (
  <ReactMarkdown
    linkTarget={linkTarget || '_blank'}
    skipHtml
    allowedElements={allowedElements}
    remarkPlugins={[remarkGfm]}
    className={clsx('aridhia-markdown-render', className)}
  >
    {value}
  </ReactMarkdown>
);

export default MarkdownRender;
